import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface ClassPerformanceNearCapacity {
  classId: string;
  className: string;
  classOccupency: number;
  classFilledCount: number;
  classTotalCapacity: number;
}

export interface GetClassPerformanceNearCapacityParams {
  sessionId: string;
}

export const getClassPerformanceNearCapacityAPI = async ({
  sessionId,
}: GetClassPerformanceNearCapacityParams) => {
  const response = await baseAPI.get<Array<ClassPerformanceNearCapacity>>(
    '/dashboard/class-performance/near-capacity',
    {
      params: {
        sessionId,
      },
    },
  );
  return response.data;
};

export const useGetClassPerformanceNearCapacity = (
  params: GetClassPerformanceNearCapacityParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.CLASS_PERFORMANCE_NEAR_CAPACITY, params.sessionId],
    queryFn: () => getClassPerformanceNearCapacityAPI(params),
    enabled: !!params.sessionId,
  });
};
